/*Javascript Document*/
$(document).ready(function () {
    $('.compare-data-tables thead').click(function () {
        $(this).siblings('tbody').slideToggle();
        $(this).closest('.compare-box').toggleClass('arrow');
    });
    $('.compare-box h3').click(function () {
        $(this).siblings('.compare-box-outer').slideToggle();
        $(this).toggleClass('arrow');
    });
  
  	 $('#comparison-select input').click(function () {
        var checkedBoxlength = $('#comparison-select input:checked').length;
        if (checkedBoxlength > 2) {
            $('.compare-error').show();
            return false;
        } else {
            $('.compare-error').css('display', 'none');
        }
        if (checkedBoxlength > 1) {
            $('#compare-btn').addClass('active');
        } else {
            $('#compare-btn').removeClass('active');
            $('.compare-desktop').hide();
        }
        display_comparison();
    });
  	var mobilehead = $('.header__main-mobile').outerHeight();
  $(document).on('click', 'a.active', function () {
        $('.compare-desktop').show();
        var anchorId = $(this).attr('href').split('#');
        var targetId = '#' + anchorId[1];
        $('html, body').animate({
            scrollTop: $(targetId).offset().top -mobilehead
        }, 500);
    });
 

});
$(window).ready(function(){

  window.onscroll = function () {
     $('.compare-cabinet-products.clearfix.issticky').slideDown().css({
		 	top:0,position:'fixed'
		 })
		 .animate({top:0}, 1000, function(){
			 
		  });
    
};
   
  
});


function display_comparison() {
        // get checkbox statuses
        var checkboxes = ['bold3', 'performance2', 'pro3', 'performanceplus2'];
        var check_statuses = {};
        var check_count = 0;
        for (var i = 0; i < checkboxes.length; i++) {
            check_statuses[ checkboxes[i] ] = $("#" + checkboxes[i]).is(':checked');
            if (check_statuses[ checkboxes[i] ]) {
                //console.log([ checkboxes[i] ]);
                check_count++;
                // add css to show true elements
                $('div.' + checkboxes[i]).show();
            } else {
                $('div.' + checkboxes[i]).hide();
            }
        }
    }
  



